//
// Auction manager.
// TODO: Integrate with zone manager down the road.
function ANAuctionManager(eventHelper, logger = null){

    this.__eventHelper          = eventHelper;
    this.__logger               = logger;
    this.__afterPageLoadTargets = new Map();
}

/**
 * Returns true if auction exists.
 * 
 * @param {String} id
 * @returns {Boolean}
 */
ANAuctionManager.prototype.doesAuctionExistForElementId = function(id){
    
    try{

        return (!!window.adsNinjaHeaderBiddingManager.__getLatestAuctionId(id));
    }
    catch(error){
        
        return false;
    }

    // return this.__mappingByElementId.hasOwnProperty(id);
};

/**
 * Wait till ads are in-view.
 * 
 * @param {Array} adUnits 
 * @returns 
 */
ANAuctionManager.prototype.waitTillAdsAreInview = function(adUnits){

    if(!adUnits || !Array.isArray(adUnits) || adUnits.length === 0){
    
        return;
    }

    var fetchMarginPercentage = 100;

    if(window.adsNinjaHeaderBiddingManager.isDesktop() && window.adsNinjaHeaderBiddingManager.getAdBehaviourValue('viewportPercentageGamRequestDesktop')){

        fetchMarginPercentage = window.adsNinjaHeaderBiddingManager.getAdBehaviourValue('viewportPercentageGamRequestDesktop');
    }
    else if(window.adsNinjaHeaderBiddingManager.isMobile() && window.adsNinjaHeaderBiddingManager.getAdBehaviourValue('viewportPercentageGamRequestMobile')){

        fetchMarginPercentage = window.adsNinjaHeaderBiddingManager.getAdBehaviourValue('viewportPercentageGamRequestMobile');
    }

    var observer = new IntersectionObserver(this.__intersectionObserverCallback.bind(this), {
        // rootMargin: `${fetchMarginPercentage}% 0px ${fetchMarginPercentage}% 0px`,
        rootMargin: '3000px 0px 3000px 0px', // TODO: This is the previous behaviour, remove this when ready to use fetch margin.
        threshold: 0.5,
        // threshold: [0.3, 0.5], // TODO: For big ads. 
    });

    if(adUnits.length === 0){
    
        return;
    }

    var unitsForAuction = [];

    for(var gamSlotKey in adUnits){

        if(!adUnits[gamSlotKey].isAdOnPage()){

            adUnits.splice(gamSlotKey, 1);
            continue;
        }

        var targetId = adUnits[gamSlotKey]['adElementId'];

        // If creative is always floating, skip intersection observer and go directly to auction.
        if(window.adsNinjaHeaderBiddingManager.isAdFloating(targetId)){

            unitsForAuction.push(adUnits[gamSlotKey]);
            continue;
        }

        var target   = adUnits[gamSlotKey].getAdZoneRootContainerElement();;

        this.__afterPageLoadTargets.set(targetId, target);
        observer.observe(target);
    }

    if(unitsForAuction.length === 0){

        return;
    }

    var afterLoadAuctionId = this.createAuction(unitsForAuction);

    window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones(afterLoadAuctionId.getGamAdSlots(), window.adsNinja.data['dynamicInjectionRefreshAdZones']);
    window.adsNinjaHeaderBiddingManager.requestHeaderBids(afterLoadAuctionId.getId());
    window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(afterLoadAuctionId.getId());
    window.adsNinjaHeaderBiddingManager.setupFloatingAdZones(afterLoadAuctionId.getGamAdSlots());
};

/**
 * Creates an auction.
 * 
 * @param {Array} unitsForAuction
 * @returns 
 */
ANAuctionManager.prototype.createAuction = function(unitsForAuction){
    
    // TODO: Builder/factory method/abstract factory?
    return window.adsNinjaHeaderBiddingManager.setup(unitsForAuction);
}

/**
 * Intersection observer callback.
 * 
 * @param {Array} entries 
 * @param {IntersectionObserver} observer
 */
ANAuctionManager.prototype.__intersectionObserverCallback = function(entries, observer){

    var unitsForAuction = [];

    for(var i = 0; i < entries.length; i++){

        var entry = entries[i];

        if(!entry.isIntersecting){

            // Skip initial call.
            continue;
        }

        var zoneKey = entry.target.dataset.key;

        if(!zoneKey){

            this.__logger.error('Zone key not found in data set!');

            return;
        }

        var zone = window.adsNinja.zoneDelegate.get(zoneKey);

        if(!zone){

            this.__logger.error('Zone not found!');

            return;
        }

        var elementId = zone.getOriginalUnitElementId();
        var adUnit    = zone.getUnit(elementId);

        if(!adUnit){

            this.__logger.error('Ad unit not found!');

            return;
        }

        // TODO: Use the 30% ratio for big ads?
        if(false && (entry.intersectionRatio < 0.3 || entry.target.clientHeight * entry.target.clientWidth < 242500 || zone.isVideo())){

            // Using the viewability metric, if this is a big ad, use a smaller intersection ratio.
            continue;
        }
        else if(entry.intersectionRatio < 0.5){

            continue;
        }

        unitsForAuction.push(adUnit);
        this.__afterPageLoadTargets.delete(elementId);
        observer.unobserve(entry.target);   
        
        // this.__logger.debug('After load auction. Observed entry.', {
        //     elementId: elementId,
        //     viewportHeight: window.innerHeight,
        //     rootBounds: entry.rootBounds,
        //     intersectionRatio: entry.intersectionRatio,
        //     boundingClientRect: entry.boundingClientRect,
        //     rootMargin: observer.rootMargin,
        //     thresholds: observer.thresholds,
        // });
    }

    if(unitsForAuction.length === 0){

        return;
    }

    var afterLoadAuctionId = this.createAuction(unitsForAuction);

    window.adsNinjaHeaderBiddingManager.setupDynamicallyInjectionRefreshAdZones(afterLoadAuctionId.getGamAdSlots(), window.adsNinja.data['dynamicInjectionRefreshAdZones']);
    window.adsNinjaHeaderBiddingManager.requestHeaderBids(afterLoadAuctionId.getId());
    window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(afterLoadAuctionId.getId());
    window.adsNinjaHeaderBiddingManager.setupFloatingAdZones(afterLoadAuctionId.getGamAdSlots());

    if(this.__afterPageLoadTargets.size === 0){

        observer.disconnect();
    }
};

window.ANAuctionManager = ANAuctionManager;